import { apiCall } from "./service";
import {
  URL_MEETINGS,
  URL_FETCH_MEETING,
  URL_CREATE_MEETING,
  URL_UPDATE_MEETING,
  URL_CANCEL_MEETING,
  URL_DELETE_MEETING,
  URL_MEETING_REGISTERY,
  URL_FETCH_MEETING_OCCURRENCE,
  URL_CREATE_MEETING_OCCURRENCE,
  URL_UPDATE_MEETING_OCCURRENCE,
  URL_CANCEL_MEETING_OCCURRENCE,
  URL_DELETE_MEETING_OCCURRENCE,
  URL_UPDATE_MEETING_DATES,
  URL_UPDATE_MEETING_OCCURRENCE_DATES,
  URL_MEETING_REGISTERY_PDF,
  URL_MEETING_OCCURRENCE_REGISTERY_PDF
} from "./URL";
const Id = localStorage.getItem("id");
export const api = {
  fetchMettingRequest(id, isOccurrence = false) {
    const url = !isOccurrence ? `${URL_FETCH_MEETING(id)}` : `${URL_FETCH_MEETING_OCCURRENCE(id)}`;
    return apiCall.get({ url });
  },
  createMettingRequest(params) {
    const url = !params.isOccurrence ? `${URL_CREATE_MEETING}` : `${URL_CREATE_MEETING_OCCURRENCE(params.parentMeetingId, params.inherit)}`;
    return apiCall.post({ url, params: params.payload });
  },
  updateMettingRequest(params) {
    const url = !params.isOccurrence ? `${URL_UPDATE_MEETING(params.id)}` : `${URL_UPDATE_MEETING_OCCURRENCE(params.id)}`;
    return apiCall.put({ url, params: params.payload });
  },
  updateMettingDatesRequest(params) {
    const url = !params.isOccurrence ? `${URL_UPDATE_MEETING_DATES(params.id)}` : `${URL_UPDATE_MEETING_OCCURRENCE_DATES(params.id)}`;
    return apiCall.patch({ url, params: params.payload });
  },
  getMettingsRequest(params) {
    const queryParams = `${params}&tz=${Intl.DateTimeFormat().resolvedOptions().timeZone}`
    return apiCall.get({ url: `${URL_MEETINGS}${queryParams}` });
  },
  cancelMettingRequest(id, editType,  isOccurrence= false) {
    const url = !isOccurrence ? `${URL_CANCEL_MEETING(id)}` : `${URL_CANCEL_MEETING_OCCURRENCE(id, editType)}`;
    return apiCall.patch({ url });
  },
  deleteMettingRequest(id, editType, isOccurrence= false) {
    const url = !isOccurrence ? `${URL_DELETE_MEETING(id)}` : `${URL_DELETE_MEETING_OCCURRENCE(id, editType)}`;
    return apiCall.delete({ url });
  },
  mettingRegisteryRequest(params) {
    const queryParams = `${params}&tz=${Intl.DateTimeFormat().resolvedOptions().timeZone}`
    return apiCall.get({ url: `${URL_MEETING_REGISTERY}${queryParams}` });
  },
  sortMettingRegisteryRequest(params) {
    return apiCall.get({ url: `${URL_MEETING_REGISTERY}${params}` });
  },
  meetingRegistoryPdfRequest(id, isOccurrence= false, dates= null) {
    let url = !isOccurrence ? `${URL_MEETING_REGISTERY_PDF(id)}` : `${URL_MEETING_OCCURRENCE_REGISTERY_PDF(id)}`;
    if(dates)
      url +=`?startTime=${dates.startTime}&endTime=${dates.endTime}`
    return apiCall.pdf({ url });
  },
};

export default api;
